export default {
  namespaced: true,

  state: {
    downloading: false,
    query: {
      mediaCd: [],
      prefectureCd: [],
      cityCd: [],
      workPlacePrefectureCd: [],
      workPlaceCityCd: [],
      stationId: '',
      stationName: '',
      jobtypeCd: [],
      industryCd: [],
      viewEndDate: '',
      acquisitionDate: '',
      selectedIntroductionCompany: 'false',
      excludedTemporaryStaffing: 'false',
      excludedNoCompanyTel: 'false',
      excludedNoCompanyUrl: 'false',
      applyKeywordsToCatchcopy: 'true',
      applyKeywordsToJobtypeName: 'true',
      applyKeywordsToJobContents: 'true',
      applyKeywordsToQualification: 'true',
      applyKeywordsToCompanyName: 'true',
      applyExcludeKeywordsToCatchcopy: 'true',
      applyExcludeKeywordsToJobtypeName: 'true',
      applyExcludeKeywordsToJobContents: 'true',
      applyExcludeKeywordsToQualification: 'true',
      applyExcludeKeywordsToCompanyName: 'true',
      prPointCd: [],
      salaryCd: '',
      salaryMin: '',
      salaryMax: '',
      employmentCd: [],
      budgetLower: '',
      budgetUpper: '',
      companyName: '',
      hakenCompanyName: '',
      companyId: '',
      keyword: [],
      excludeKeyword: [],
      fromAcquisitionDate: '',
      toAcquisitionDate: '',
      order: '',
      orderDirection: '',
    },
  },
  getters: {
    apiQuery: state =>
      ({
        mediaCd: state.query.mediaCd.map(m => (m.value || m)).join(','),
        prefectureCd: state.query.prefectureCd.map(p => (p.value || p)).join(','),
        cityCd: state.query.cityCd.map(p => (p.value || p)).join(','),
        stationId: state.query.stationId,
        // stationNameはstationIdがあるので除外
        workPlacePrefectureCd: state.query.workPlacePrefectureCd.map(p => (p.value || p)).join(','),
        workPlaceCityCd: state.query.workPlaceCityCd.map(p => (p.value || p)).join(','),
        jobtypeCd: state.query.jobtypeCd.map(t => (t.value || t)).join(','),
        industryCd: state.query.industryCd.map(i => (i.value || i)).join(','),
        viewEndDate: state.query.viewEndDate,
        acquisitionDate: state.query.acquisitionDate,
        selectedIntroductionCompany: state.query.selectedIntroductionCompany,
        excludedTemporaryStaffing: state.query.excludedTemporaryStaffing,
        excludedNoCompanyTel: state.query.excludedNoCompanyTel,
        excludedNoCompanyUrl: state.query.excludedNoCompanyUrl,
        applyKeywordsToCatchcopy: state.query.applyKeywordsToCatchcopy,
        applyKeywordsToJobtypeName: state.query.applyKeywordsToJobtypeName,
        applyKeywordsToJobContents: state.query.applyKeywordsToJobContents,
        applyKeywordsToQualification: state.query.applyKeywordsToQualification,
        applyKeywordsToCompanyName: state.query.applyKeywordsToCompanyName,
        applyExcludeKeywordsToCatchcopy: state.query.applyExcludeKeywordsToCatchcopy,
        applyExcludeKeywordsToJobtypeName: state.query.applyExcludeKeywordsToJobtypeName,
        applyExcludeKeywordsToJobContents: state.query.applyExcludeKeywordsToJobContents,
        applyExcludeKeywordsToQualification: state.query.applyExcludeKeywordsToQualification,
        applyExcludeKeywordsToCompanyName: state.query.applyExcludeKeywordsToCompanyName,
        prPointCd: state.query.prPointCd.map(pp => (pp.value || pp)).join(','),
        salaryCd: state.query.salaryCd,
        salaryMin: state.query.salaryMin,
        salaryMax: state.query.salaryMax,
        employmentCd: state.query.employmentCd.map(ec => (ec.value || ec)).join(','),
        budgetLower: state.query.budgetLower,
        budgetUpper: state.query.budgetUpper,
        companyName: state.query.companyName,
        hakenCompanyName: state.query.hakenCompanyName,
        companyId: state.query.companyId,
        keyword: state.query.keyword.map(i => (i.value || i)).join(','),
        excludeKeyword: state.query.excludeKeyword.map(i => (i.value || i)).join(','),
        fromAcquisitionDate: state.query.fromAcquisitionDate,
        toAcquisitionDate: state.query.toAcquisitionDate,
        order: state.query.order,
        orderDirection: state.query.orderDirection,
      })
    ,
  },
  mutations: {
    downloading: (state, downloading) => state.downloading = downloading,
    mediaCd: (state, value) => state.query.mediaCd = value,
    prefectureCd: (state, value) => state.query.prefectureCd = value,
    cityCd: (state, value) => state.query.cityCd = value,
    workPlacePrefectureCd: (state, value) => state.query.workPlacePrefectureCd = value,
    workPlaceCityCd: (state, value) => state.query.workPlaceCityCd = value,
    stationId: (state, value) => state.query.stationId = value,
    stationName: (state, value) => state.query.stationName = value,
    jobtypeCd: (state, value) => state.query.jobtypeCd = value,
    industryCd: (state, value) => state.query.industryCd = value,
    viewEndDate: (state, value) => state.query.viewEndDate = value,
    acquisitionDate: (state, value) => state.query.acquisitionDate = value,
    selectedIntroductionCompany: (state, value) => state.query.selectedIntroductionCompany = value,
    excludedTemporaryStaffing: (state, value) => state.query.excludedTemporaryStaffing = value,
    excludedNoCompanyTel: (state, value) => state.query.excludedNoCompanyTel = value,
    excludedNoCompanyUrl: (state, value) => state.query.excludedNoCompanyUrl = value,
    applyKeywordsToCatchcopy: (state, value) => state.query.applyKeywordsToCatchcopy = value,
    applyKeywordsToJobtypeName: (state, value) => state.query.applyKeywordsToJobtypeName = value,
    applyKeywordsToJobContents: (state, value) => state.query.applyKeywordsToJobContents = value,
    applyKeywordsToQualification: (state, value) => state.query.applyKeywordsToQualification = value,
    applyKeywordsToCompanyName: (state, value) => state.query.applyKeywordsToCompanyName = value,
    applyExcludeKeywordsToCatchcopy: (state, value) => state.query.applyExcludeKeywordsToCatchcopy = value,
    applyExcludeKeywordsToJobtypeName: (state, value) => state.query.applyExcludeKeywordsToJobtypeName = value,
    applyExcludeKeywordsToJobContents: (state, value) => state.query.applyExcludeKeywordsToJobContents = value,
    applyExcludeKeywordsToQualification: (state, value) => state.query.applyExcludeKeywordsToQualification = value,
    applyExcludeKeywordsToCompanyName: (state, value) => state.query.applyExcludeKeywordsToCompanyName = value,
    prPointCd: (state, value) => state.query.prPointCd = value,
    salaryCd: (state, value) => state.query.salaryCd = value,
    salaryMin: (state, value) => state.query.salaryMin = value,
    salaryMax: (state, value) => state.query.salaryMax = value,
    employmentCd: (state, value) => state.query.employmentCd = value,
    budgetLower: (state, value) => state.query.budgetLower = value,
    budgetUpper: (state, value) => state.query.budgetUpper = value,
    companyName: (state, value) => state.query.companyName = value,
    hakenCompanyName: (state, value) => state.query.hakenCompanyName = value,
    companyId: (state, value) => state.query.companyId = value,
    keyword: (state, value) => state.query.keyword = value,
    excludeKeyword: (state, value) => state.query.excludeKeyword = value,
    fromAcquisitionDate: (state, value) => state.query.fromAcquisitionDate = value,
    toAcquisitionDate: (state, value) => state.query.toAcquisitionDate = value,
    order: (state, value) => state.query.order = (value === 'created_at') ? 'acquisition_date' : value,
    orderDirection: (state, value) => state.query.orderDirection = value,
    addExcludeKeyword: (state, value) => {
      state.query.excludeKeyword.push(value)
    },
    addKeyword: (state, value) => {
      state.query.keyword.push(value)
    },
    removeExcludeKeyword: (state, index) => {
      state.query.excludeKeyword.splice(index, 1)
    },
    removeKeyword: (state, index) => {
      state.query.keyword.splice(index, 1)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/searchJob.js